import Badge from "./Badge";
import Avatar from "./Avatar";
import { productType } from "types/productType";
import { useEffect, useState } from "react";

export default function ViewContents3 ({
	
	description
}: any) {

	let [ visible, setVisible ] = useState <string> ("hidden");
	//let [ desc, setDesc ] = useState <string> ("");

	useEffect(() => {

		if (description === undefined || description === null || description === "") {
			setVisible("hidden");
		} else {
			setVisible("");
		}
	}, [description])

	return (
		<div id="information" className={`listingSection__wrap space-y-0 p-0 ${visible}`}>
			
			
						
			
			<div
				className="ql-editor !min-h-[50px] !p-0 !m-0"
				dangerouslySetInnerHTML={{ __html: description}}
			/>
			
		</div>
	);
};